import { render, staticRenderFns } from "./PaginaPrincipal.vue?vue&type=template&id=4d4ede72"
import script from "./PaginaPrincipal.vue?vue&type=script&lang=js"
export * from "./PaginaPrincipal.vue?vue&type=script&lang=js"
import style0 from "./PaginaPrincipal.vue?vue&type=style&index=0&id=4d4ede72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports